<!-- eslint-disable vue/no-deprecated-v-bind-sync -->

<template>
  <div
    id="toolsFilesSection"
    class="p-1"
  >
    <input
      ref="file"
      type="file"
      style="display: none"
      multiple
      @change="addFileExplorer"
    >

    <b-container class="bv-example-row">
      <b-row
        class="header-tools"
        align-v="center"
        align-h="between"
      >
        <b-col
          cols="7"
          class="p-0"
        >
          <b-dropdown
            size="sm"
            variant="link"
            toggle-class="text-decoration-none"
            no-caret
          >
            <template #button-content>
              <AddDocLogo class="logo" />
            </template>
            <b-dropdown-item-button @click="$refs.file.click()">
              <b-icon
                icon="file-earmark-plus-fill"
                aria-hidden="true"
                class="mr-2"
                scale="1.2"
              />
              Add file from explorer
            </b-dropdown-item-button>
            <b-dropdown-item-button @click="linkReportFiles">
              <b-icon
                icon="link"
                aria-hidden="true"
                class="mr-2"
                scale="1.2"
              />
              Link files from report
            </b-dropdown-item-button>
          </b-dropdown>
        </b-col>

        <b-col
          cols="5"
          class="p-0"
          md="auto"
        >
          <b-button
            :pressed.sync="showExtracted"
            variant="outline-primary"
            size="sm"
            @mouseover="onHover('ReportViewer/Files/showProcessed')"
            @mouseleave="onLeave"
          >
            <span v-if="showExtracted">Hide</span>

            <span v-else>Show</span>
            Processed
          </b-button>
        </b-col>
      </b-row>

      <b-row
        v-if="showExtracted"
        @mouseover="onHover('ReportViewer/Files/processed')"
        @mouseleave="onLeave"
        @click="select('ReportViewer/Files/processed')"
      >
        <ProcessedData class="px-2" />
      </b-row>

      <b-row
        v-else
        no-float
        @mouseover="onHover('ReportViewer/Files/DragArea')"
        @mouseleave="onLeave"
        @click="select('ReportViewer/Files/DragArea')"
      >
        <div
          v-cloak
          :class="[
            'dropzone-area p-1 mx-1',
            dragging ? 'dropzone-over' : '',
          ]"
          @drop.prevent="addFileDrag"
          @dragover.prevent="dragging = true"
          @dragleave="dragging = false"
        >
          <p
            v-if="dragging"
            id="drag-message"
          >
            Files to Upload (Drag them over)
          </p>

          <b-container>
            <b-row
              v-for="reportLinkedId in getCurrentReportViewer.reportLinked"
              :key="reportLinkedId"
              class="file-element-list py-2 px-0 my-1 shadow-sm"
            >
              <b-col
                cols="1"
                align-v="center"
                class="p-0 m-0 pl-2"
              >
                <img
                  class="icon-file"
                  :src="'../../../Icons/djuliLogo.png'"
                  alt="Icon"
                >
              </b-col>

              <b-col
                cols="10"
                align-v="center"
                class="p-0 m-0 pl-2"
              >
                <a 
                  class="caption-file"
                  :href="`/reportViewer/${getCurrentClusterNavigation}/${getCurrentProjectNavigation}/report/${reportLinkedId}`"
                  target="_blank"
                >
                  {{ getDictReportsByUIdReportViewer[reportLinkedId].name }}
                </a>
              </b-col>

              <b-col
                cols="1"
                align-v="center"
                class="p-0 m-0 float-right"
              >
                <b-button
                  size="sm"
                  variant="danger"
                  class="p-0 m-0 mr-2 float-right"
                  @click="removeReportLink(reportLinkedId)"
                >
                  <b-icon
                    icon="x-circle-fill"
                    aria-label="Remove"
                    class="icon-remove"
                  />
                </b-button>
              </b-col>
            </b-row>
            <b-row
              v-for="file in getCurrentReportViewer.files"
              :key="file.name"
              class="file-element-list py-2 px-0 my-1 shadow-sm"
            >
              <b-col
                cols="1"
                align-v="center"
                class="p-0 m-0 pl-2"
              >
                <img
                  class="icon-file"
                  :src="'../../../Icons/' + file.icon"
                  alt="Icon"
                >
              </b-col>

              <b-col
                cols="10"
                align-v="center"
                class="p-0 m-0 pl-2"
              >
                <p class="caption-file">
                  {{ file.name }} ({{ fileSizeSI(file.size) }})
                </p>
              </b-col>

              <b-col
                cols="1"
                align-v="center"
                class="p-0 m-0 float-right"
              >
                <b-button
                  size="sm"
                  variant="danger"
                  class="p-0 m-0 mr-2 float-right"
                  @click="removeFile(file)"
                >
                  <b-icon
                    icon="x-circle-fill"
                    aria-label="Remove"
                    class="icon-remove"
                  />
                </b-button>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import AddDocLogo from '@/assets/SVG/addDocument.svg';
import { InBackEndParser } from '@/functions/extractData.js';
import { fromFile } from '@/common/sharedDefinitions/dataExtractor.js';
import { isPictureFile, isXLSXFile } from '@/common/sharedDefinitions/dataExtractors/baseExtractor.js';
import { mapActions, mapGetters } from 'vuex';
import ReportInfo from '@/functions/ReportInfo.js';
import ProcessedData from './ProcessedData';
import { ExtraConfigKey } from '@/common/sharedDefinitions/commonPlotDefinitions'
import { Comparison_Type, getScanFilesList } from '@/common/sharedDefinitions/reportDefinitions.js';

const notifyZone = 'ToolsFilesSection'

export default {
    name: notifyZone,
    filters: {
        kb: function (val) {
            return Math.floor(val / 1024);
        },
    },
    components: {
        AddDocLogo,
        ProcessedData,
    },
    data() {
        return {
            dragging: false,
            newFiles: false,
            showExtracted: false,
            ExtraConfigKey,
        };
    },
    computed: mapGetters([
        'getCurrentReportViewer',
        'getExtractedDataBinaryMiddleware',
        'getDictIdReportsReportViewer',
        'getDictReportsByUIdReportViewer',
        'getCurrentClusterNavigation',
        'getCurrentProjectNavigation',
    ]),
    mounted() {
        this.matchFilesList();
    },
    methods: {
        ...mapActions([
            'extractBinaryMiddleware',
            'addMessageTerminalSection',
            'setReportStatesListReportViewer',
            'setMessageVisibleReportViewer',
            'setMessageTextReportViewer',
            'saveRawFileMiddleware',
            'setConfigReportModifiedReportViewer',
            'setContextOnHover',
            'setScanFilesListReportViewer',
            'setMappingSetReportViewer',
            'setContextFixElement',
        ]),
        fileSizeSI(a, b, c, d, e) {
            return (
                ((b = Math),
                    (c = b.log),
                    (d = 1e3),
                    (e = (c(a) / c(d)) | 0),
                    a / b.pow(d, e)).toFixed(2) +
                ' ' +
                (e ? 'kMGTPEZY'[--e] + 'B' : 'Bytes')
            );
        },
        addFileDrag(e) {
            this.dragging = false;
            const droppedFiles = e.dataTransfer.files;
            if (!droppedFiles) return;
            this.addFile(droppedFiles);
        },
        addFileExplorer(e) {
            const selectedFiles = e.target.files;
            if (!selectedFiles) return;
            this.addFile(selectedFiles);
        },
        async addFile(files) {
            for (let n = 0; n < files.length; n++) {
                const f = files[n];
                let fileName = f.name;

                if (
                    this.getCurrentReportViewer.files.some(
                        rFile => rFile.name === fileName,
                    )
                ) {
                    //Check if the file is already in the report
                    let counter = 1;
                    let newName = fileName;
                    while (
                        this.getCurrentReportViewer.files.some(
                            rFile => rFile.name === newName,
                        )
                    ) {
                        newName = fileName.replace('.', `(${counter}).`);
                        counter++;
                    }
                    try {
                        await this.$confirm(
                            `The report already contains the file "${f.name}" do you want to save it as "${newName}"?`,
                            'Repeated file',
                            'question',
                        );
                        fileName = newName;
                    } catch {
                        continue;
                    }
                }
                this.setMessageVisibleReportViewer(true);
                let extractedInfo;
                try {
                    if (InBackEndParser.isBackEndExtraction(fileName)) {
                        this.setMessageTextReportViewer(`Extracting data from the file '${fileName}' in the Back-End...`);
                        const backEndParser = new InBackEndParser();
                        extractedInfo = await backEndParser.extract(f, this);
                    } else {
                        this.setMessageTextReportViewer(
                            `Extracting data from file '${fileName}' locally...`,
                        );
                        extractedInfo = await new Promise(resolve => {
                            const reader = new FileReader();
                            reader.onload = (function (f, resolve, parent) {
                                return async function (e) {
                                    extractedInfo = await fromFile(
                                        parent,
                                        fileName,
                                        e.target.result,
                                        parent.getCurrentReportViewer,
                                    );
                                    resolve(extractedInfo);
                                };
                            })(f, resolve, this);
                            reader.onerror = e => {
                                throw e;
                            };
                            if (isPictureFile(fileName)) {
                                reader.readAsDataURL(f);
                            } else if (isXLSXFile(fileName)) {
                                reader.readAsArrayBuffer(f);
                            } else {
                                reader.readAsText(f); //Read the files
                            }
                        });
                    }
                } catch (error) {

					this.setMessageVisibleReportViewer(false);
					const errTitle = `Error in File '${fileName}'`;
					const errText = error;
					const errZone = 'Tools File Selection';
					this.$notifTerm.addNotification(
						this.$notifTerm.typesNotif.ERROR,
						errTitle,
						errText,
						errZone,
					);
					continue;
				}
				const warningsLen = extractedInfo.warnings.length;
				if (warningsLen > 0) {
					this.$notify({
						group: 'AppGeneralUser',
						title: 'File extraction',
						type: 'warn',
						text: `Data extracted from file '${fileName}' with ${warningsLen} warnings`,
					});
					this.addMessageTerminalSection({
						type: 'WARNING',
						text: `Data extracted from file '${fileName}' with ${warningsLen} warnings`,
					});
					extractedInfo.warnings.forEach(warning => {
						this.addMessageTerminalSection({
							type: 'WARNING',
							text: warning,
						});
					});
				}
				if (extractedInfo.success) {
					let newProcessedFile = {
						name: fileName,
						size: f.size,
						extractedData: extractedInfo.processedData,
						dataType: extractedInfo.dataType,
						icon: extractedInfo.icon,
					};
					if (typeof extractedInfo.type !== 'undefined') {
						newProcessedFile.type = extractedInfo.type;
					}
					if (!('files' in this.getCurrentReportViewer)) {
						this.$set(this.getCurrentReportViewer, 'files', []);
					}
					this.getCurrentReportViewer.files.push(newProcessedFile); //Add to the report
					if ( this.getCurrentReportViewer.type !== Comparison_Type) {
            const statesReport = await ReportInfo.getStatesList(this.getCurrentReportViewer)
						this.setReportStatesListReportViewer(statesReport);
						const scanFilesList = await getScanFilesList(this.getCurrentReportViewer)
						this.setScanFilesListReportViewer(scanFilesList);
						this.setMappingSetReportViewer(ReportInfo.getMapping(this.getCurrentReportViewer));
					}
					this.newFiles = true;
					const currentReport = this.$route.params.reportId;
					const currentProject = this.$route.params.projectId;
					const currentCluster = this.$route.params.clusterId;
					this.setConfigReportModifiedReportViewer();
					this.setMessageTextReportViewer(
						`Uploading data from file '${fileName}'...`,
					);
					let setRawFileResp = false;
					let errorMssg = '';
					try {
						setRawFileResp = await this.saveRawFileMiddleware({
							clusterId: currentCluster,
							projectId: currentProject,
							reportId: currentReport,
							filename: fileName,
							file: f,
						});
					} catch (e) {
						errorMssg = e.message;

                        setRawFileResp = false;
                    }
                    if (!setRawFileResp) {
                        const warnMssg = `The raw file ${fileName} could not be stored in the File Storage, it is recommended to remove and try again. ${errorMssg}`;
                        this.$notify({
                            group: 'AppGeneralUser',
                            title: 'Raw Data fail storage',
                            type: 'warn',
                            text: warnMssg,
                        });
                        this.addMessageTerminalSection({
                            type: 'WARNING',
                            text: warnMssg,
                        });
                    }
                    this.setMessageVisibleReportViewer(false);
                } else {
                    this.setMessageVisibleReportViewer(false);
                    this.$notify({
                        group: 'AppGeneralUser',
                        title: `Error in File '${fileName}'`,
                        type: 'error',
                        text: extractedInfo.lastError,
                    });
                    this.addMessageTerminalSection({
                        type: 'ERROR',
                        text: extractedInfo.lastError,
                    });
                    extractedInfo.warnings.forEach(warning => {
                        this.addMessageTerminalSection({
                            type: 'WARNING',
                            text: warning,
                        });
                    });
                }
            }
        },
        matchFilesList() {
            if (!('files' in this.getCurrentReportViewer)) {
                this.$set(this.getCurrentReportViewer, 'files', []);
            }
        },
        removeFile(file) {
            this.setConfigReportModifiedReportViewer();
            let indexFile = this.getCurrentReportViewer.files.findIndex(
                f => f.name === file.name,
            );
            this.getCurrentReportViewer.files.splice(indexFile, 1);
        },
        removeReportLink(reportId){
          this.setConfigReportModifiedReportViewer();
          const indexReport = this.getCurrentReportViewer.reportLinked.findIndex(r => r === reportId);
          this.getCurrentReportViewer.reportLinked.splice(indexReport, 1);
        },
        async linkReportFiles(){
          let idReportFiles;
          try{
            idReportFiles = await this.$prompt(
              'Please include the Id of the reports separated by comma or range separated by dash. Example: 10-15, 2',
              '',
              'Link report files',
              'question'
            );
          }catch{
            return
          }
          let newLinkedReportIncluded = false
          for(const idReport of idReportFiles.split(',')){
            if(idReport.includes('-')){
              const idReportRange = idReport.split('-')
              const minRange = parseInt(idReportRange[0])
              const maxRange = parseInt(idReportRange[1])
              if(isNaN(minRange) || typeof(this.getDictIdReportsReportViewer[minRange]) === 'undefined'
                 || isNaN(maxRange) || typeof(this.getDictIdReportsReportViewer[maxRange]) === 'undefined'){
                const errTitle = 'Id range not identified';
                const errText = `Range '${idReport}' not valid. You can check the left list of reports. Report range skipped`;
                this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR, errTitle, errText, notifyZone);
                continue;
              }
              if(minRange > maxRange || (maxRange - minRange) > 10){
                const errTitle = 'Invalid id range';
                const errText = `Range '${idReport}' not valid. It should contain 'minRange-maxRange' and maximum 10 reports. Report range skipped`;
                this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR, errTitle, errText, notifyZone);
                continue;
              }
              for(let idRange = minRange; idRange <= maxRange; idRange++){
                newLinkedReportIncluded |= this.linkReport(idRange, idRange)
              }
            }else{
              const idReportNum = parseInt(idReport)
              newLinkedReportIncluded |= this.linkReport(idReportNum, idReport)
            }
          }
          if(newLinkedReportIncluded){
            this.setConfigReportModifiedReportViewer();
          }
        },
        linkReport(idReportNum, idReport){
          if(isNaN(idReportNum) || typeof(this.getDictIdReportsReportViewer[idReportNum]) === 'undefined'){
            const errTitle = 'Id not identified';
            const errText = `Id '${idReport}' not found. You can check the left list of reports. Report skipped`;
            this.$notifTerm.addNotification(this.$notifTerm.typesNotif.ERROR, errTitle, errText, notifyZone);
            return false
          }
          const reportUniqueId = this.getDictIdReportsReportViewer[idReportNum].id
          if(typeof(this.getCurrentReportViewer.reportLinked) === 'undefined')
            this.$set(this.getCurrentReportViewer, 'reportLinked', []);
          if(this.getCurrentReportViewer.reportLinked.includes(reportUniqueId) || this.getCurrentReportViewer.id === reportUniqueId){
            const warnTitle = 'Id duplicated';
            const warnText = `Id '${idReport}' already exists in the linked reports`;
            this.$notifTerm.addNotification(this.$notifTerm.typesNotif.WARNING, warnTitle, warnText, notifyZone);
            return false
          }else{
            this.getCurrentReportViewer.reportLinked.push(reportUniqueId);
            return true
          }
        },
        onHover(route) {
            this.setContextOnHover(route);
        },
        onLeave() {
            this.setContextOnHover(null);
        },
        select(route) {
            this.setContextFixElement(route);
        },
    },
};
</script>

<style scoped>
.dropzone-over {
    border: 5px solid #6488d5 !important;
    opacity: 0.5 !important;
}

div.dropzone-area {
    border: none;
    height: 98%;
    opacity: 1;
    min-height: 27rem;
    width: 100%;
}

.btn-icon {
    display: inline-flex;
    align-items: center;
    margin-right: 10px;
    padding: 6px 10px;
    border-radius: 6px;
    border: 2px solid currentColor;
    margin-bottom: 5px;
}

.btn-icon-add {
    color: #4fc08d;
}

.btn-icon-update {
    color: #1d78c1;
}

.logo {
    width: 30px;
    height: 30px;
}

.header-tools {
    border-bottom: #707070;
    border-bottom-style: solid;
    width: 100% !important;
    position: relative !important;
    margin: 0;
}

#drag-message {
    position: absolute;
    left: 5.2rem;
    top: 23rem;
    font-weight: bold;
    color: #5d7ec5;
}

.file-element-list {
    border: solid 1.5px;
    font-size: small;
    border-radius: 6px;
}

.caption-file {
    padding: 0;
    margin: 0;
}

.icon-file {
    width: 20px;
    height: 20px;
}
</style>
